export default () => {
	// Find all figure elements within editor-content
	const figures = document.querySelectorAll(".editor-content figure");

	figures.forEach((figure) => {
		const img = figure.querySelector("img");
		if (!img) return;

		// Get image dimensions
		const width = img.naturalWidth;
		const height = img.naturalHeight;

		// Calculate aspect ratio
		const aspectRatio = width / height;

		// Remove existing classes if any
		figure.classList.remove("image-with-caption__horizontal", "image-with-caption__vertical");

		// Add appropriate class based on aspect ratio
		if (aspectRatio > 1) {
			figure.classList.add("image-with-caption__horizontal");
		} else {
			figure.classList.add("image-with-caption__vertical");
		}
	});
};
